export const toCurrency = (value) => {
  if (value) {
    try {
      return Number(value).toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    } catch (error) {
      console.log(error);
      return "";
    }
  }

  return "";
};

export const toCurrencyNumber = (value) => {
  if (value) {
    try {
      value =
        value.toString().substring(0, value.toString().length - 2) +
        "." +
        value.toString().substring(value.toString().length - 2);

      if (
        value.split(".")[0] === "00" ||
        value.split(".")[0] === "000" ||
        value.split(".")[0] === "0000" ||
        value.split(".")[0] === "00000"
      )
        return value;

      return Number(value);
    } catch (error) {
      console.log(error);
      return "";
    }
  }

  return "";
};

export const validateEmail = (email) => {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
};

export const toCurrencyDecimal = (value) => {
  if (value && value !== "0") {
    try {
      value =
        value.toString().substring(0, value.toString().length - 2) +
        "," +
        value.toString().substring(value.toString().length - 2);

      return value;
    } catch (error) {
      console.log(error);
      return "";
    }
  }

  return "";
};

export const toDate = (value) => {
  try {
    return new Date(value);
  } catch (error) {
    console.log(error);
    return "";
  }
};

// Internal helper: parse ISO string with optional timezone offset into wall-time parts (no TZ math)
// Returns null if it doesn't match; consumers should fallback to Date
function parseIsoWithOffsetParts(input) {
  if (typeof input !== "string") return null;
  const m = input.match(
    // eslint-disable-next-line no-useless-escape
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2})(?:\.(\d+))?)?(Z|[+\-]\d{2}:\d{2})?$/
  );
  if (!m) return null;
  return {
    year: m[1],
    month: m[2],
    day: m[3],
    hour: m[4],
    minute: m[5],
    second: m[6] ?? "00",
    millisecond: (m[7] ?? "0").slice(0, 3),
  };
}

export const toTime = (value) => {
  try {
    const parts = parseIsoWithOffsetParts(value);
    if (parts) {
      return `${parts.hour}:${parts.minute}:${parts.second}`;
    }
    return new Date(value).toLocaleTimeString("pt-BR");
  } catch (error) {
    console.log(error);
    return "";
  }
};

export const toDateTime = (value) => {
  try {
    if (typeof value === "string") {
      if (value.includes("/")) return value;
      if (value.includes("0001")) return "";
      if (value.includes("1900")) return "";
    }

    const data = new Date(value).toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });

    return data;
  } catch (error) {
    console.log(error);
    return "";
  }
};

export const toDateString = (value) => {
  try {
    if (typeof value === "string") {
      if (value.includes("/")) return value;
      if (value.includes("0001")) return "";
    }

    const data = new Date(value).toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    });

    return data;
  } catch (error) {
    console.log(error);
    return "";
  }
};

export const toDateISOString = (date) => {
  try {
    if (date) {
      const parts = parseIsoWithOffsetParts(date);
      if (parts) {
        return `${parts.year}-${parts.month}-${parts.day}`;
      }
      let dateTime = new Date(date);
      let day =
        dateTime.getDate() < 10 ? "0" + dateTime.getDate() : dateTime.getDate();
      let month =
        dateTime.getMonth() + 1 < 10
          ? "0" + (dateTime.getMonth() + 1)
          : dateTime.getMonth() + 1;
      let year = dateTime.getFullYear();
      return `${year}-${month}-${day}`;
    }
  } catch (error) {
    console.log(error);
  }
  return "";
};

export const stringToDate = (dateString) => {
  try {
    if (dateString) {
      let date = dateString.split("-");
      let day = date[2] ? Number(date[2]) : 0;
      let month = date[1] ? Number(date[1]) - 1 : 0;
      let year = date[0] ? Number(date[0]) : 0;

      return new Date(year, month, day);
    }
  } catch (error) {
    console.log(error);
  }
  return "";
};

export const toDateTimeISOString = (date) => {
  try {
    if (date) {
      const parts = parseIsoWithOffsetParts(date);
      if (parts) {
        const ms = parts.millisecond.toString().padStart(3, "0");
        // Mantém hora local contida na string, mas marca como UTC com Z (mesmo comportamento anterior)
        return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}.${ms}Z`;
      }
      let dateTime = new Date(date);
      let day =
        dateTime.getDate() < 10 ? "0" + dateTime.getDate() : dateTime.getDate();
      let month =
        dateTime.getMonth() + 1 < 10
          ? "0" + (dateTime.getMonth() + 1)
          : dateTime.getMonth() + 1;
      let year = dateTime.getFullYear();
      let hour =
        dateTime.getHours() < 10
          ? "0" + dateTime.getHours()
          : dateTime.getHours();
      let minutes =
        dateTime.getMinutes() < 10
          ? "0" + dateTime.getMinutes()
          : dateTime.getMinutes();
      let seconds =
        dateTime.getSeconds() < 10
          ? "0" + dateTime.getSeconds()
          : dateTime.getSeconds();
      let mileseconds = dateTime.getMilliseconds();
      return `${year}-${month}-${day}T${hour}:${minutes}:${seconds}.${mileseconds}Z`;
    }
  } catch (error) {
    console.log(error);
  }
  return "";
};

 export const toDateISOStringFormatD = (date) => {
    if (!date) return "";

    // Se for string URL-encoded, decodifica
    const decoded = typeof date === "string" ? decodeURIComponent(date) : date;
    const dateTime = new Date(decoded);

    const day = String(dateTime.getDate()).padStart(2, "0");
    const month = String(dateTime.getMonth() + 1).padStart(2, "0");
    const year = dateTime.getFullYear();

    return `${year}-${month}-${day}`;
  };

export const toDateTimeISOStringFormat = (date) => {
  try {
    if (date) {
      const parts = parseIsoWithOffsetParts(date);
      if (parts) {
        return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
      }
      let dateTime = new Date(date);
      let day =
        dateTime.getDate() < 10 ? "0" + dateTime.getDate() : dateTime.getDate();
      let month =
        dateTime.getMonth() + 1 < 10
          ? "0" + (dateTime.getMonth() + 1)
          : dateTime.getMonth() + 1;
      let year = dateTime.getFullYear();
      let hour =
        dateTime.getHours() < 10
          ? "0" + dateTime.getHours()
          : dateTime.getHours();
      let minutes =
        dateTime.getMinutes() < 10
          ? "0" + dateTime.getMinutes()
          : dateTime.getMinutes();
      return `${year}-${month}-${day}T${hour}:${minutes}`;
    }
  } catch (error) {
    console.log(error);
  }
  return "";
};

export const toDecimal = (value) => {
  if (value) {
    var decimals = value.toString().replace(",", ".");

    return Number(decimals);
    // if (decimals.length > 1) {
    //   var initial = decimals[0];
    //   var end = decimals[1];
    //   if (decimals[1].length === 1) {
    //     end = decimals[1] + "0";
    //   }

    //   return `${initial}${end}`;
    // } else {
    //   return value + "00";
    // }
  }

  return 0;
};

export const toDecimalInt = (value) => {
  if (value) {
    var decimals = value.toString().split(".");

    if (decimals.length > 1) {
      var initial = decimals[0];
      var end = decimals[1];
      if (decimals[1].length === 1) {
        end = decimals[1] + "0";
      }

      return `${initial}${end}`;
    } else {
      return value + "00";
    }
  }

  return 0;
};

export const toSpeedFormat = (value) => {
  if (value) {
    return `${value.toFixed(2)} km/h`;
  }
  return 0;
};

export const toDistanceFormat = (value) => {
  if (value) {
    return `${value.toFixed(2)} km`;
  }
  return 0;
};

export function validateCNPJ(value) {
  if (!value) return false;

  value = value.replace(/[^\d]+/g, "");
  if (
    !value ||
    value.length !== 14 ||
    value === "11111111111111" ||
    value === "22222222222222" ||
    value === "33333333333333" ||
    value === "44444444444444" ||
    value === "55555555555555" ||
    value === "66666666666666" ||
    value === "77777777777777" ||
    value === "88888888888888" ||
    value === "99999999999999"
  ) {
    return false;
  }

  // Aceita receber o valor como string, número ou array com todos os dígitos
  const isString = typeof value === "string";
  const validTypes =
    isString || Number.isInteger(value) || Array.isArray(value);

  // Elimina valor em formato inválido
  if (!validTypes) return false;
  /*
  // Filtro inicial para entradas do tipo string
  if (isString) {
    // Limita ao máximo de 18 caracteres, para CNPJ formatado
    if (value.length > 18) return false;

    // Teste Regex para verificar se é uma string apenas dígitos válida
    const digitsOnly = /^\d{14}$/.test(value);
    // Teste Regex para verificar se é uma string formatada válida
    const validFormat = /^\d{2}.\d{3}.\d{3}\/\d{4}-\d{2}$/.test(value);

    // Se o formato é válido, usa um truque para seguir o fluxo da validação
    if (digitsOnly || validFormat) return true;
    // Se não, retorna inválido
    else return false;
  }
*/
  // Guarda um array com todos os dígitos do valor
  const match = value.toString().match(/\d/g);
  const numbers = Array.isArray(match) ? match.map(Number) : [];

  // Valida a quantidade de dígitos
  if (numbers.length !== 14) return false;

  // Elimina inválidos com todos os dígitos iguais
  const items = [...new Set(numbers)];
  if (items.length === 1) return false;

  // Cálculo validador
  const calc = (x) => {
    const slice = numbers.slice(0, x);
    let factor = x - 7;
    let sum = 0;

    for (let i = x; i >= 1; i--) {
      const n = slice[x - i];
      sum += n * factor--;
      if (factor < 2) factor = 9;
    }

    const result = 11 - (sum % 11);

    return result > 9 ? 0 : result;
  };

  // Separa os 2 últimos dígitos de verificadores
  const digits = numbers.slice(12);

  // Valida 1o. dígito verificador
  const digit0 = calc(12);
  if (digit0 !== digits[0]) return false;

  // Valida 2o. dígito verificador
  const digit1 = calc(13);
  return digit1 === digits[1];
}

export function validateCPF(cpf) {
  if (typeof cpf !== "string") return false;
  cpf = cpf.replace(/[\s.-]*/gim, "");
  if (
    !cpf ||
    cpf.length !== 11 ||
    cpf === "00000000000" ||
    cpf === "11111111111" ||
    cpf === "22222222222" ||
    cpf === "33333333333" ||
    cpf === "44444444444" ||
    cpf === "55555555555" ||
    cpf === "66666666666" ||
    cpf === "77777777777" ||
    cpf === "88888888888" ||
    cpf === "99999999999"
  ) {
    return false;
  }
  var soma = 0;
  var resto;
  for (var i = 1; i <= 9; i++)
    soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(9, 10))) return false;
  soma = 0;
  for (i = 1; i <= 10; i++)
    soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(10, 11))) return false;
  return true;
}

export function generateUUID() {
  // Public Domain/MIT
  var d = new Date().getTime(); //Timestamp
  var d2 =
    (typeof performance !== "undefined" &&
      performance.now &&
      performance.now() * 1000) ||
    0; //Time in microseconds since page-load or 0 if unsupported
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = Math.random() * 16; //random number between 0 and 16
    if (d > 0) {
      //Use timestamp until depleted
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      //Use microseconds since page-load if supported
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
}

export const generateGUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    // eslint-disable-next-line no-mixed-operators
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

export const toDateISOStringFormat = (date) => {
  try {
    if (date) {
      // expected format: "2023-04-24T15:02:41.374Z"
      const parts = parseIsoWithOffsetParts(date);
      if (parts) {
        return `${parts.year}-${parts.month}-${parts.day}T`;
      }
      let dateTime = new Date(date);
      let day =
        dateTime.getDate() < 10 ? "0" + dateTime.getDate() : dateTime.getDate();
      let month =
        dateTime.getMonth() + 1 < 10
          ? "0" + (dateTime.getMonth() + 1)
          : dateTime.getMonth() + 1;
      let year = dateTime.getFullYear();
      return `${year}-${month}-${day}T`;
    }
  } catch (error) {
    console.log(error);
  }
  return "";
};

export const toTimeISOStringFormat = (date) => {
  try {
    if (date) {
      const parts = parseIsoWithOffsetParts(date);
      if (parts) {
        return `${parts.hour}:${parts.minute}`;
      }
      let dateTime = new Date(date);
      let hour =
        dateTime.getHours() < 10
          ? "0" + dateTime.getHours()
          : dateTime.getHours();
      let minutes =
        dateTime.getMinutes() < 10
          ? "0" + dateTime.getMinutes()
          : dateTime.getMinutes();
      return `${hour}:${minutes}`;
    }
  } catch (error) {
    console.log(error);
  }
  return "";
};

// const formatPhoneNumber = (value) => {
//   return value
//     .replace(/\D/g, "") // Remove tudo que não for número
//     .replace(/^(\d{2})(\d)/, "($1) $2") // Adiciona parênteses no DDD
//     .replace(/(\d{5})(\d)/, "$1-$2") // Adiciona o traço
//     .slice(0, 15); // Limita ao formato "(99) 99999-9999"
// };

// function formatToE164(phone) {
//   return phone.replace(/\D/g, "").replace(/^0?/, "");
// }

export const truncateText = (text, maxLength = 20) => {
  if (!text) return ""; // Caso o campo esteja vazio ou undefined
  return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
};

export const toLocalDateTimeString = (date) => {
    if (!date) return null;
    const pad = (n) => n.toString().padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};
